import Hamburguer from "../../../assets/images/generico/Hamburguer";
import { getLocalStorage } from "global/utils/safeJsonParse";
import HeaderTimer from "../HeaderTimer/HeaderTimer";
import { getStrDate } from "../../../../global/utils/diasData";
import React, { useState } from "react";
import "./HeaderbarHome.css";
import { HeaderBarMainContainer, MenuContainerMobile } from "./localStyle";
import isIosNative from "../../../../global/utils/isIosNative";
import IconBlack from "_+_Portal/assets/images/generico/IconBack";
import TimerAT from "../TimerAT/TimerAT";

// const { Storage } = Plugins;

const HeaderbarHome = ({
  turnos,
  onShowBurguerHandle,
  handleClickVolver,
  time,
  timerGlobal,
  flgTimerGlobal,
  desactivarTimer,
}) => {
  const [showDropPerfil, setShowDropPerfil] = useState(false);
  const [iosInfo, setIosInfo] = useState(false);
  let idTerminal = getLocalStorage("idTerminal");

  async function infoIos() {
    const isIosNativeMobile = await isIosNative.logDeviceInfo();
    setIosInfo(isIosNativeMobile);
    return isIosNativeMobile;
  }
  infoIos();

  const onHandleClickAvatar = () => {
    if (!showDropPerfil) {
      setShowDropPerfil(true);
    } else {
      setShowDropPerfil(false);
    }
  };

  return (
    <React.Fragment>
      <div
        className={`ptur-HeaderbarDiv-background ${
          !showDropPerfil ? "disable" : ""
        }`}
        onClick={onHandleClickAvatar}
      ></div>
      <HeaderBarMainContainer className="c-white" $isIos={iosInfo}>
        {turnos ? (
          <button
            className="ptur-headerbarFiltros-volverBtn"
            onClick={handleClickVolver}
          >
            <IconBlack />
            <span className="ptur-headerbarFiltros-volverTxt rb18m">
              VOLVER
            </span>
          </button>
        ) : (
          <div className="logoHeader">
            <img
              className="ptur-logoHeader"
              src={
                process.env.PUBLIC_URL + "/assets/images/empresa/IsoLogo.png"
              }
              alt="logo"
            ></img>
          </div>
        )}
        {idTerminal && !desactivarTimer && (
            <TimerAT
              currentTime={time}
              timerGlobal={(timer) => timerGlobal(timer)}
              flgTimerGlobal={flgTimerGlobal}
            />
        )}

        <div className="ptur-RightMenu">
          <div className="ptur-headerBarHome-DiaHora">
            <p id="ptur-DiaResponsive" className="rb18m">
              {getStrDate(new Date())}
              <span className="ptur-timer">
                <HeaderTimer />
              </span>
            </p>
          </div>

          <div
            onClick={onShowBurguerHandle}
            className="ptur-burguerPerfil pointer"
          >
            <MenuContainerMobile>
              <Hamburguer />
            </MenuContainerMobile>
          </div>
        </div>
      </HeaderBarMainContainer>
    </React.Fragment>
  );
};

export default HeaderbarHome;
